export default "__VITE_ASSET__61d36ecb__"